import type { Invoice } from './types';

const LABELS: Record<Invoice['ksefState'], string> = { brak: 'Robocza', oczekuje: 'Wysyłanie', wysylana: 'Wysyłanie', przyjeta: 'W KSeF', odrzucona: 'Odrzucona', offline: 'Offline' };

const deadlineText = (iso: string) => new Date(iso).toLocaleString('pl-PL', { timeZone: 'Europe/Warsaw', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });

/** The invoice's state in KSeF as a small label: "Robocza", "Wysyłanie", "W KSeF", "Odrzucona", "Offline – dosłać do…". */
export function ksefLabel(inv: Pick<Invoice, 'ksefState' | 'ksefDeadline'> & { state?: Invoice['state'] }): string {
  if (inv.state === 'anulowana') return 'Anulowana';
  if (inv.ksefState === 'offline' && inv.ksefDeadline) return `Offline – dosłać do ${deadlineText(inv.ksefDeadline)}`;
  return LABELS[inv.ksefState];
}

export function KsefBadge({ invoice }: { invoice: Pick<Invoice, 'ksefState' | 'ksefDeadline'> & { state?: Invoice['state'] } }) {
  return (
    <span className="inv-badge" data-state={invoice.state === 'anulowana' ? 'anulowana' : invoice.ksefState} data-testid="ksef-badge">
      {ksefLabel(invoice)}
    </span>
  );
}

/** While KSeF has not answered yet, the screens ask again every 5 s. */
export const waitingForKsef = (inv: Pick<Invoice, 'ksefState'>) => inv.ksefState === 'oczekuje' || inv.ksefState === 'wysylana';
